import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Target, Award, Users, Zap, CheckCircle2, ArrowRight, HeartHandshake, Clock, Smile } from 'lucide-react';
import { AnimatedSection, AnimatedGrid, AnimatedGridItem } from '../components/AnimatedSection';
export function About() {
  return <div className="w-full" data-id="element-96" data-mp="2ejhyrgtu5pxk">
      {/* HERO SECTION */}
      <section className="relative bg-navy text-white py-24 md:py-32 overflow-hidden" data-id="element-97" data-mp="328kegj4wt8pf">
        <div className="absolute inset-0 z-0" data-id="element-98" data-mp="326g9dxv9y3nk">
          <img src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?q=80&w=2070&auto=format&fit=crop" alt="Electrical engineering plans" className="w-full h-full object-cover opacity-20" data-id="element-99" data-mp="376cek0fpk14p" />
          <div className="absolute inset-0 bg-navy/90 mix-blend-multiply" data-id="element-100" data-mp="2xb12jpvop80n"></div>
          <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-101" data-mp="1gtn3rgndvrap"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center" data-id="element-102" data-mp="1lvce0u2s80xq">
          <AnimatedSection data-id="element-103" data-mp="1uitfn6m2pdt2">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight mb-6 max-w-4xl mx-auto" data-id="element-104" data-mp="1ui1w4u5r36j5">
              Electrical Expertise You Can{' '}
              <span className="text-accent" data-id="element-105" data-mp="23k1d5mgrmam3">Trust</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-106" data-mp="1yj3vdazo3il4">
              At The Electrical Professionals Inc, we are committed to
              delivering safe, dependable, and professional electrical services
              for residential and commercial customers.
            </p>
          </AnimatedSection>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-2 bg-accent" data-id="element-107" data-mp="2mb2ay765g042"></div>
      </section>

      {/* COMPANY STORY */}
      <section className="py-20 md:py-28 bg-white" data-id="element-108" data-mp="2w75dhe4wy0rj">
        <div className="max-w-7xl mx-auto px-6" data-id="element-109" data-mp="2w7x5kezaxgd2">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-110" data-mp="2r82f2cjfussj">
            <AnimatedSection className="order-2 md:order-1 relative" data-id="element-111" data-mp="2r5y79jif59mz">
              <div className="aspect-[4/5] rounded-sm overflow-hidden shadow-2xl relative z-10" data-id="element-112" data-mp="1ow7mlr09lhn5">
                <video src="https://cdn.magicpatterns.com/uploads/1VSaidLQ8zJWNpQctUD4w3/kling_20260618_VIDEO__Image1Cre_150_0%20(1).mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-113" data-mp="1swrikr93qf7p" />
              </div>
              <div className="absolute top-10 -left-10 w-full h-full border-2 border-accent/20 rounded-sm z-0 hidden md:block" data-id="element-114" data-mp="2cjyzowtmpyph"></div>
            </AnimatedSection>

            <AnimatedSection className="order-1 md:order-2" data-id="element-115" data-mp="2gmlwzd92kbu2">
              <h2 className="font-display text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-116" data-mp="2ljudl9ekk7t7">
                About The Electrical Professionals Inc
              </h2>
              <div className="w-20 h-1.5 bg-accent mb-8" data-id="element-117" data-mp="r6cmjceygstf"></div>

              <div className="text-lg text-slate-600 leading-relaxed" data-id="element-118" data-mp="r8yw1hlepiea">
                <p className="mb-6" data-id="element-119" data-mp="joy0131a6wb3">
                  At The Electrical Professionals Inc, we are committed to
                  delivering safe, dependable, and professional electrical
                  services for residential and commercial customers throughout
                  Central Florida. Our team understands that electrical systems
                  are one of the most important components of any home or
                  business, which is why we approach every project with
                  precision, integrity, and attention to detail.
                </p>
                <p data-id="element-120" data-mp="sn9whlotwobg">
                  From troubleshooting and repairs to panel upgrades,
                  installations, and emergency electrical services, we provide
                  solutions designed to keep your property running safely and
                  efficiently. No matter the size of the project, our goal is to
                  deliver quality workmanship, clear communication, and
                  exceptional customer service from start to finish.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* MISSION & VALUES */}
      <section className="py-20 md:py-28 bg-slate-50 border-y border-slate-200" data-id="element-121" data-mp="r74a0s1oq42a">
        <div className="max-w-7xl mx-auto px-6" data-id="element-122" data-mp="w44if9m0biwk">
          <AnimatedSection className="text-center max-w-4xl mx-auto mb-20" data-id="element-123" data-mp="w2ten9skab5g">
            <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 px-3 py-1.5 rounded-full mb-6" data-id="element-124" data-mp="1jv05jtfippxh">
              <Target className="w-4 h-4 text-yellow-400" data-id="element-125" data-mp="1atsjc9qa0fjr" />
              <span className="text-sm font-semibold tracking-wider text-yellow-400 uppercase" data-id="element-126" data-mp="1at8z2md5lf2k">
                Our Mission
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-navy leading-tight" data-id="element-127" data-mp="3vjhvgezlhn8r">
              "To provide safe, reliable, and affordable electrical services
              while building lasting customer relationships through
              professionalism and quality workmanship."
            </h2>
          </AnimatedSection>

          <AnimatedSection data-id="element-128" data-mp="3n2hcvokkszsd">
            <h2 className="font-display text-3xl font-bold text-navy mb-8 tracking-tight text-center" data-id="element-129" data-mp="3n5dafbsihmga">
              Our Core Values
            </h2>
            <div className="w-20 h-1.5 bg-accent mx-auto mb-12" data-id="element-130" data-mp="x3vk9g8514n"></div>
            <AnimatedGrid className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-131" data-mp="39b2pl5jmycfi">
              {[{
              title: 'Safety',
              icon: Shield
            }, {
              title: 'Integrity',
              icon: HeartHandshake
            }, {
              title: 'Reliability',
              icon: Clock
            }, {
              title: 'Professionalism',
              icon: Award
            }, {
              title: 'Customer Satisfaction',
              icon: Smile
            }].map((value, i) => <AnimatedGridItem key={i} className="bg-white p-6 rounded-sm shadow-sm border border-slate-100 text-center" data-id="element-132" data-mp="3fbin2njn36x9" data-mpi={i}>
                  <div className="bg-slate-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-133" data-mp="3k4tjrvuqm7bg">
                    <value.icon className="w-8 h-8 text-accent" data-id="element-134" data-mp="2sbkropub06et" />
                  </div>
                  <h3 className="font-display font-bold text-lg text-navy" data-id="element-135" data-mp="2wcwkt5cdz9rr">
                    {value.title}
                  </h3>
                </AnimatedGridItem>)}
            </AnimatedGrid>
          </AnimatedSection>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 bg-navy text-white" data-id="element-136" data-mp="368pumgyq0p5u">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-137" data-mp="gkyvxgsrp00m">
          <AnimatedSection data-id="element-138" data-mp="lja4zpb8n6hs">
            <h2 className="font-display text-3xl font-bold mb-2" data-id="element-139" data-mp="lmo9b33gpprv">
              Ready to start your project?
            </h2>
            <p className="text-slate-300" data-id="element-140" data-mp="2139ep8acoo1s">
              Contact us today for a free, no-obligation estimate.
            </p>
          </AnimatedSection>
          <AnimatedSection delay={0.2} data-id="element-141" data-mp="1wb9m60wm0xf8">
            <Link to="/quote" className="bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-sm font-semibold transition-colors inline-flex items-center gap-2" data-id="element-142" data-mp="1re9btdsq98ib">
              Request a Free Quote <ArrowRight className="w-5 h-5" data-id="element-143" data-mp="1ici9mixebjt7" />
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}